export default __webpack_public_path__ + "static/media/PIKACHU.23872528.gif";